<template>
  <LayoutDefault :title="$t('ordemResultado.lis.titulo')">
    <MonitorFilter @search="search"/>
    <b-card v-if="recipients.length > 0 || loading" body-class="p-0" class="mt-3 d-flex flex-column p-0">
      <Table class="flex-fill"
             :isLoading="loading"
             :items="recipients"
             @click-recipient="loadRecipient"/>
      <Paginator :page="paginator.page"
                 :per-page="paginator.per_page"
                 :total="paginator.total"
                 @change="paginate"/>
    </b-card>
    <EmptyData v-else title=" "/>
    <RecipientModal id="recipient-modal" :title="$t('ordemResultado.modal.titulo')"/>
  </LayoutDefault>
</template>

<script>
import CountDown from "@/components/CountDown";
import EmptyData from "@/components/EmptyData";
import Paginator from "@/components/Paginator";
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from 'vuex';
import RecipientModal from "./RecipientModal";
import MonitorFilter from "./MonitorFilter";
import Table from "./Table";

export default {
  name: "ObservationLis",
  components: {
    RecipientModal,
    MonitorFilter,
    EmptyData,
    Table,
    CountDown,
    Paginator,
    LayoutDefault
  },
  computed: {
    ...mapGetters({
      recipients: 'recipient/all',
      recipient: 'recipient/current',
      loading: 'recipient/isLoading',
      paginator: 'recipient/pagination',
      filtro: 'monitorFilter/all'
    }),
  },
  data() {
    return {
      additionalFields: [{
        key: 'ordered_code',
        label: this.$t('ordemResultado.link.numero_pedido')
      }]
    }
  },
  methods: {
    ...mapActions([
      'recipient/listAll',
      'recipient/listOne',
      'recipient/listOrdersByVnsId',
      'recipient/listReportsByVnsId',
      'monitorFilter/setSpecific',
      'monitorFilter/reset',
    ]),
    search() {
      this.$store.commit(
          'recipient/setPagination',
          {
            page: this.paginator.page,
            per_page: this.paginator.per_page
          },
          {root: true}
      )

      let customFilter = {...this.filtro};
      customFilter.company_filter = (this.filtro.company_filter !== null) ? this.filtro.company_filter.value : null ;

      this.$store.commit('recipient/setAll', [], {root: true})
      this['recipient/listAll'](customFilter)
    },
    paginate(pagination) {
      this.$store.commit('recipient/setPagination', pagination, {root: true})
      this.search()
    },
    async loadRecipient(item) {
      this.$store.commit('recipient/setCurrent', {}, {root: true})
      this.$store.commit('recipient/setCurrentMonitor', item, {root: true})
      await this['recipient/listOne']()
      this.$bvModal.show('recipient-modal')
      let vnsId = item.vns_id;

      if (this.recipient instanceof Array) {
        this.recipient.map(async r => {
          let payload = {recipientId: r.id, vnsId: vnsId};
          await this['recipient/listOrdersByVnsId'](payload)
          await this['recipient/listReportsByVnsId'](payload)
        })
      }

      if (!this.recipient instanceof Array){
        let payload = {recipientId: this.recipient.id, vnsId: vnsId};
        await this['recipient/listOrdersByVnsId'](payload)
        await this['recipient/listReportsByVnsId'](payload)
      }
    }
  },
  mounted() {
    this['monitorFilter/setSpecific']({integration_type: 'LIS'})
    this['monitorFilter/reset']()
    this.paginate({page: 1, per_page: 10, total: 0})
  }
}
</script>

<style lang="scss" scoped>
.mx-datepicker-range,
.mx-datepicker {
  width: 100% !important;
}
</style>
